
// accordion
class AccordionComponents extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('.js-accordion-button');
    this.content = this.button.nextElementSibling;

    this.button.addEventListener('click', () => {
      this.expanded = this.getAttribute('aria-expanded');

      this.setAttribute('aria-expanded', (this.expanded === 'false').toString());
      (this.expanded === 'false') ? this.content.style.maxHeight = this.content.scrollHeight + "px" : this.content.style.maxHeight = null;
    });
  }
}

customElements.define('accordion-item', AccordionComponents);

// lookbook popup
class PopUpComponents extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('.lookbook__popup-button');
    this.buttonClose = this.querySelector('.lookbook__popup-close');

    this.button.addEventListener('click', this.togglePopUp.bind(this));
    this.buttonClose.addEventListener('click', this.togglePopUp.bind(this));
  }

  togglePopUp() {
    this.expanded = this.getAttribute('aria-hidden');
    this.setAttribute('aria-hidden', (this.expanded === 'false').toString());

    const siteBody = document.querySelector('body');
    (this.expanded === 'false') ? siteBody.classList.remove('scroll-disabled') : siteBody.classList.add('scroll-disabled');
  }
}

customElements.define('lookbook-popup', PopUpComponents);

// social share
class SocialShareComponents extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('.share__button').forEach((button) => {
      button.addEventListener('click', () => {
        const pageUrl = window.location.href;
        const socialPlatform = button.getAttribute('data-social');

        let shareUrl;
        switch (socialPlatform) {
          case 'facebook':
            shareUrl = `https://www.facebook.com/sharer.php?u=${encodeURIComponent(pageUrl)}`;
            break;
          case 'twitter':
            shareUrl = `https://twitter.com/share?url=${encodeURIComponent(pageUrl)}`;
            break;
          case 'pinterest':
            shareUrl = `https://pinterest.com/pin/create/bookmarklet/?url=${encodeURIComponent(pageUrl)}`;
            break;
          case 'whatsapp':
            shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(pageUrl)}`;
            break;
          default:
            console.error('Invalid social platform');
            return;
        }

        window.open(shareUrl, 'Share', 'width=550,height=400');
      });
    });
  }
}

customElements.define('social-share', SocialShareComponents);
